import 'css-chunksrc/client/pages/documentsPage/documentsPage/preview/defaultRenderer/styles.scss';export default {
  "renderer": "_renderer_163q4_1"
};